var _style, _g, _pattern, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.7 120.9",
    style: {
      enableBackground: "new 0 0 113.7 120.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FC8DE4;}\n\t.st2{fill:#F9A7E9;}\n\t.st3{fill:none;stroke:#E2DEDE;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{fill:url(#SVGID_1_);}\n\t.st5{fill:url(#);}\n")), /*#__PURE__*/React.createElement("pattern", {
    x: 644.3,
    y: -454.7,
    width: 566.9,
    height: 850.4,
    patternUnits: "userSpaceOnUse",
    id: "New_Pattern_6",
    viewBox: "183.7 -1028.6 566.9 850.4",
    style: {
      overflow: "visible"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 183.7,
    y: -1028.6,
    className: "st0",
    width: 566.9,
    height: 850.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M677.5-3.6c-17.7-3.4-58.7-11.3-85.9-45.6c-41.2-52-24.9-132.2,5.3-180.5c26.9-43.2,65.2-61.6,115.7-85.9 c62.3-29.9,107.1-51.5,147.2-35.1c64.6,26.5,94.8,142.3,59.6,227.9C878.8-24,760.2,12.3,677.5-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.6-3.6C92.9-7,51.9-14.9,24.7-49.2c-41.2-52-24.9-132.2,5.3-180.5c26.9-43.2,65.2-61.6,115.7-85.9 c62.3-29.9,107.1-51.5,147.2-35.1c64.6,26.5,94.8,142.3,59.6,227.9C311.9-24,193.3,12.3,110.6-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.1-428.8c-17.7-3.4-58.7-11.3-85.9-45.6c-41.2-52-24.9-132.2,5.3-180.5c26.9-43.2,65.2-61.6,115.7-85.9 c62.3-29.9,107.1-51.5,147.2-35.1C641-749.4,671.2-633.6,636-548C595.3-449.2,476.8-412.9,394.1-428.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M677.5-854c-17.7-3.4-58.7-11.3-85.9-45.6c-41.2-52-24.9-132.2,5.3-180.5c26.9-43.2,65.2-61.6,115.7-85.9 c62.3-29.9,107.1-51.5,147.2-35.1c64.6,26.5,94.8,142.3,59.6,227.9C878.8-874.4,760.2-838.1,677.5-854z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.6-854c-17.7-3.4-58.7-11.3-85.9-45.6c-41.2-52-24.9-132.2,5.3-180.5c26.9-43.2,65.2-61.6,115.7-85.9 c62.3-29.9,107.1-51.5,147.2-35.1c64.6,26.5,94.8,142.3,59.6,227.9C311.9-874.4,193.3-838.1,110.6-854z"
  })))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_1_",
    xlinkHref: "#New_Pattern_6",
    patternTransform: "matrix(9.838345e-02 0 0 0.1046 -7939.7607 -8645.6309)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    width: 113.7,
    height: 120.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern1);
export default __webpack_public_path__ + "static/media/Pattern1.12ec706e11294347c5581779d6b1f1f2.svg";
export { ForwardRef as ReactComponent };